import React, {
  useCallback,
  useState,
  useDeferredValue,
  useTransition,
} from 'react';
import {
  useRefinementList,
  useClearRefinements,
  // eslint-disable-next-line import/no-unresolved
} from 'react-instantsearch-next';

import MobileProductFiltersButton from './components/MobileProductFiltersButton';
import MobileProductFiltersModal from './components/MobileProductFiltersModal';

const MobileProductFilters = ({ productsCount }) => {
  const { items: refinedFilters, refine: refineSearch } = useRefinementList({
    attribute: 'type',
  });

  const items = useDeferredValue(refinedFilters);

  const {
    canRefine: canClear,
    refine: clearSearchRefinement,
  } = useClearRefinements({
    includedAttributes: ['type'],
  });

  const [, startTransition] = useTransition();

  const [isMobileFiltersModalOpen, setIsMobileFiltersModalOpen] = useState(
    false
  );

  const handleOpenModal = useCallback(() => {
    setIsMobileFiltersModalOpen(true);
  }, [setIsMobileFiltersModalOpen]);

  const handleCloseModal = useCallback(() => {
    setIsMobileFiltersModalOpen(false);
  }, [setIsMobileFiltersModalOpen]);

  const refine = useCallback(
    value => {
      startTransition(() => {
        refineSearch(value);
      });
    },
    [refineSearch]
  );

  const clearRefinement = useCallback(() => {
    clearSearchRefinement();
  }, [clearSearchRefinement]);

  return (
    <>
      <MobileProductFiltersButton onClick={handleOpenModal} items={items} />

      <MobileProductFiltersModal
        isOpen={isMobileFiltersModalOpen}
        onClose={handleCloseModal}
        productsCount={productsCount}
        items={items}
        refine={refine}
        canClear={canClear}
        clearRefinement={clearRefinement}
      />
    </>
  );
};

export default MobileProductFilters;
